import React from 'react'
import LoadingSpinner from './LoadingSpinner'

interface Props {
  children: React.ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
}

/**
 * 지도 페이지 전용 Error Boundary.
 * Script error(네이버 맵 API 인증 실패 등) 시 React 에러 오버레이 대신 안내 UI 표시.
 */
class MapErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('[MapErrorBoundary]', error, errorInfo)
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null })
  }

  render() {
    if (this.state.hasError) {
      const isScriptError =
        this.state.error?.message === 'Script error.' ||
        (typeof this.state.error?.message === 'string' &&
          this.state.error?.message?.includes('Script error'))

      return (
        <div className="w-full h-full flex flex-col items-center justify-center bg-backgroundColorBg1 px-20px">
          <LoadingSpinner size={28} borderWidth={4} className="mb-24px" />
          <p className="text-style-body1 text-textColorText2 text-center mb-8px">
            지도를 불러오는데 실패했습니다
          </p>
          <p className="text-style-captionM text-textColorText2 text-center mb-24px">
            {isScriptError
              ? '네이버 클라우드 플랫폼에서 현재 URL을 웹 서비스 URL에 등록해주세요.'
              : '잠시 후 다시 시도해주세요.'}
          </p>
          <button
            onClick={this.handleRetry}
            className="px-32px py-12px bg-4B3621-80% rounded-8px text-white text-style-bodyM font-bold"
          >
            다시 시도
          </button>
        </div>
      )
    }

    return this.props.children
  }
}

export default MapErrorBoundary
